<style scoped lang="scss">

</style>

<template>
    <div v-if="application">
        <fieldset class="agreement-container">
            <legend class="agreement-title">
                {{ __('tenant.priv_title') }}
            </legend>

            <div class="uk-grid">
                <div class="uk-width-1-1">
                    <h4>{{ __('tenant.instructions') }}:</h4>
                    <p>
                        {{ __('tenant.priv_instructions') }}
                    </p>
                </div>
            </div>

            <div class="uk-grid">
                <div class="uk-width-1-1">
                    <div class="uk-block uk-block-default policy-content">
                        <p v-html="application.program.settings['privacy-policy-content']"></p>
                    </div>
                </div>
            </div>

            <div class="uk-grid" v-if="application.household">
                <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">
                    <div v-if="signatureEnabled(member)">
                        <validated-section :field="'signature_'+member.id" :errors="errors">
                            <signature-box @updated="onSignatureUpdated"
                                           :user-key="member.id"
                                           :is-signed="signatureData[member.id] && signatureData[member.id].privacy_policy_signed_at !== null"
                                           :completed="signatureData[member.id] && signatureData[member.id].completed"
                                           :name="member.first_name + ' ' + member.last_name"
                                           :color="programSettings['primary-program-color']"
                            ></signature-box>
                        </validated-section>

                    </div>
                </div>
            </div>
        </fieldset>

    </div>
</template>
<script>
    import {mapState, mapGetters} from 'vuex';
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    export default {
        name: "PrivacyPolicy",
        components: {ValidatedSection, SignatureBox},
        data() {
            return {
                errors: {},
                signatureData: {},
            }
        },
        computed: {
            ...mapState('Application', {
                application: state => state.application,
                signatures: state => state.signatures,
            }),
            ...mapGetters('Application', [ 'programSettings' ])
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            initData() {
                _.each(this.application.household.members, member => {
                    if(this.signatureEnabled(member)) {
                        const signatureFiltered = member.signatures.find(item => item.key === `app-privacy-policy`)
                        if(signatureFiltered) {
                            this.$set(this.signatureData, member.id, { privacy_policy_signed_at: signatureFiltered.created_at, completed: true });
                        }
                    }
                })
            },
            signatureEnabled(member) {
                let res = false
                if (member.age >= 18 && (member.household_member_key === 1 || this.application.program.settings['require-memeber-signature']))
                    res = true
                return res
            },
            onSignatureUpdated($event) {
                if(!this.signatures[$event.key]) {
                    this.$set(this.signatures, $event.key, {});
                }
                this.$set(this.signatureData, $event.key, { privacy_policy_signed_at: $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null});
            },
            async validateStep() {
                this.errors = {};
                // Local Validation
                for(var i in this.application.household.members) {
                    let member = this.application.household.members[i];
                    if(this.signatureEnabled(member)) {
                        if(!this.signatureData[member.id]) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[member.id] && this.signatureData[member.id].privacy_policy_signed_at == null) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;


                // Server Side Validation
                try {
                    let response = await this.save();
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            save() {
                let data = {
                    signatures: this.signatureData,
                }
                return axios.put(`/api/hope/applications/${this.application.id}/step-5`, data)
            }
        }
    }
</script>
